/**
 * Grade matrix live API
 * Grade matrix live API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type EnablerFactorModel = 'MYSELF' | 'UP_TO_3' | 'UP_TO_5' | 'UP_TO_10' | 'OVER_10';

export const EnablerFactorModel = {
    Myself: 'MYSELF' as EnablerFactorModel,
    UpTo3: 'UP_TO_3' as EnablerFactorModel,
    UpTo5: 'UP_TO_5' as EnablerFactorModel,
    UpTo10: 'UP_TO_10' as EnablerFactorModel,
    Over10: 'OVER_10' as EnablerFactorModel
};

